export default __webpack_public_path__ + "static/media/13_tag_restaurant.426f69b9.svg";